import { CategoryType } from '@diritto/common/content/constants';
import {
  CategoryNavigationMenu,
  CategoryNavigationMenuPath,
  GlobalNavigationMenu,
  LibraryNavigationMenu,
  LibraryNavigationMenuPath,
  RankingActivityPointNavigationMenu,
  RankingNavigationMenu,
} from '@diritto/common/navigation/constant';

export const CategoryTypeDisplayOnEditorList = [
  CategoryType.Fantasy,
  CategoryType.BL,
  CategoryType.RomanceFantasy,
  CategoryType.Romance,
  CategoryType.Any,
];

export const CategoryTypeDisplayOnContestEditorList = [CategoryType.Fantasy];

export const NewGlobalNavigationMenuDisplayList = [
  GlobalNavigationMenu.Home,
  GlobalNavigationMenu.Explore,
  GlobalNavigationMenu.Ranking,
  GlobalNavigationMenu.My,
  // GlobalNavigationMenu.Quest,
];

export const NewPartnerGlobalNavigationMenuDisplayList = [
  GlobalNavigationMenu.Home,
  GlobalNavigationMenu.Explore,
  GlobalNavigationMenu.Ranking,
  GlobalNavigationMenu.My,
];

export const GlobalNavigationMenuText = {
  [GlobalNavigationMenu.Home]: '홈',
  [GlobalNavigationMenu.Explore]: '탐색',
  [GlobalNavigationMenu.Ranking]: '베스트',
  [GlobalNavigationMenu.My]: '보관함',
  [GlobalNavigationMenu.Quest]: '퀘스트',
};

export const GlobalNavigationMenuHref = {
  [GlobalNavigationMenu.Home]: '/',
  [GlobalNavigationMenu.Explore]: '/explore',
  [GlobalNavigationMenu.Ranking]: '/ranking',
  [GlobalNavigationMenu.My]: '/my',
  [GlobalNavigationMenu.Quest]: '/quest',
};

export const ExploreNavigationMenuPath = {
  [CategoryNavigationMenu.All]: `${GlobalNavigationMenuHref[GlobalNavigationMenu.Explore]}/${
    CategoryNavigationMenuPath[CategoryNavigationMenu.All]
  }`,
  [CategoryNavigationMenu.Fantasy]: `${GlobalNavigationMenuHref[GlobalNavigationMenu.Explore]}/${
    CategoryNavigationMenuPath[CategoryNavigationMenu.Fantasy]
  }`,
  [CategoryNavigationMenu.BL]: `${GlobalNavigationMenuHref[GlobalNavigationMenu.Explore]}/${
    CategoryNavigationMenuPath[CategoryNavigationMenu.BL]
  }`,
  [CategoryNavigationMenu.RomanceFantasy]: `${GlobalNavigationMenuHref[GlobalNavigationMenu.Explore]}/${
    CategoryNavigationMenuPath[CategoryNavigationMenu.RomanceFantasy]
  }`,
  [CategoryNavigationMenu.Romance]: `${GlobalNavigationMenuHref[GlobalNavigationMenu.Explore]}/${
    CategoryNavigationMenuPath[CategoryNavigationMenu.Romance]
  }`,
  [CategoryNavigationMenu.Any]: `${GlobalNavigationMenuHref[GlobalNavigationMenu.Explore]}/${
    CategoryNavigationMenuPath[CategoryNavigationMenu.Any]
  }`,
};

export const RankingNavigationSeriesMenuPath = {
  [CategoryNavigationMenu.All]: `${GlobalNavigationMenuHref[GlobalNavigationMenu.Ranking]}/${
    CategoryNavigationMenuPath[CategoryNavigationMenu.All]
  }`,
  [CategoryNavigationMenu.Fantasy]: `${GlobalNavigationMenuHref[GlobalNavigationMenu.Ranking]}/${
    CategoryNavigationMenuPath[CategoryNavigationMenu.Fantasy]
  }`,
  [CategoryNavigationMenu.BL]: `${GlobalNavigationMenuHref[GlobalNavigationMenu.Ranking]}/${
    CategoryNavigationMenuPath[CategoryNavigationMenu.BL]
  }`,
  [CategoryNavigationMenu.RomanceFantasy]: `${GlobalNavigationMenuHref[GlobalNavigationMenu.Ranking]}/${
    CategoryNavigationMenuPath[CategoryNavigationMenu.RomanceFantasy]
  }`,
  [CategoryNavigationMenu.Romance]: `${GlobalNavigationMenuHref[GlobalNavigationMenu.Ranking]}/${
    CategoryNavigationMenuPath[CategoryNavigationMenu.Romance]
  }`,
  [CategoryNavigationMenu.Any]: `${GlobalNavigationMenuHref[GlobalNavigationMenu.Ranking]}/${
    CategoryNavigationMenuPath[CategoryNavigationMenu.Any]
  }`,
};

export const RankingNavigationMenuPath = {
  [RankingNavigationMenu.Series]: '/ranking',
  [RankingNavigationMenu.ActivityPoint]: '/ranking/activity-point/all',
};

export const MyNavigationMenuPath = {
  [LibraryNavigationMenu.Recently]: `${GlobalNavigationMenuHref[GlobalNavigationMenu.My]}/${
    LibraryNavigationMenuPath[LibraryNavigationMenu.Recently]
  }`,
  [LibraryNavigationMenu.Favorites]: `${GlobalNavigationMenuHref[GlobalNavigationMenu.My]}/${
    LibraryNavigationMenuPath[LibraryNavigationMenu.Favorites]
  }`,
};

export const RankingActivityPointNavigationMenuPath = {
  [RankingActivityPointNavigationMenu.My]: '/ranking/activity-point/my',
  [RankingActivityPointNavigationMenu.All]: '/ranking/activity-point/all',
};

export enum DirittoStudioContentMenuType {
  Synopsis = 'Synopsis',
  Episodes = 'Episodes',
  ContentDetail = 'ContentDetail',
  ContestApply = 'ContestApply',
}
